import { Dispatch, SetStateAction, useState } from "react";
import FormElement from "./form/form-element";

export interface VideoUploadParams {
  id: string;
  label: string;
  previewUrl?: string;
  setVideoFile: Dispatch<SetStateAction<File | undefined>>;
  className?: string;
}

export default function VideoUploader(params: VideoUploadParams) {
  const [preview, setPreview] = useState(params.previewUrl ?? "");

  const onChange = (e: any) => {
    createImage(e.target.files[0]);
  };

  const createImage = (file: any) => {
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
      params.setVideoFile(file);
    }
  };

  return (
    <FormElement
      id={params.id}
      label={params.label}
      className={params.className}
    >
      <div className="col-span-full flex items-center gap-x-8">
        <video
          className="h-60 w-60 rounded-lg"
          controls
          controlsList="nofullscreen nodownload noremoteplayback noplaybackrate "
          src={preview}
        >
          Your browser does not support the video tag.
        </video>

        <div>
          <label className="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
            <span>Change video</span>
            <input
              className="hidden"
              type="file"
              accept=".mp4"
              onChange={onChange}
            />
          </label>
          <p className="mt-2 text-xs leading-5 text-gray-400">MP4</p>
        </div>
      </div>
    </FormElement>
  );
}
